<div class="kn-web-tooltip" [tooltip]="tooltip" [tooltipDirection]="direction">
    <slot name="content"></slot>
</div>